// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.web.user.property.listings.accountview.zrm.enums.AccountViewListingStatus

export enum AccountViewListingStatus {
  ARCHIVED = 'ARCHIVED',
  DECLINED = 'DECLINED',
  EXPIRED = 'EXPIRED',
  EXPIRES_SOON = 'EXPIRES_SOON',
  LEASED = 'LEASED',
  OFF_MARKET = 'OFF_MARKET',
  PARTIALLY_PUBLISHED = 'PARTIALLY_PUBLISHED',
  PUBLISHED = 'PUBLISHED',
  PUBLISHING = 'PUBLISHING',
  UNABLE_TO_PUBLISH = 'UNABLE_TO_PUBLISH',
  WAITLISTED = 'WAITLISTED',
}

export const AccountViewListingStatus_values = [
  AccountViewListingStatus.ARCHIVED,
  AccountViewListingStatus.DECLINED,
  AccountViewListingStatus.EXPIRED,
  AccountViewListingStatus.EXPIRES_SOON,
  AccountViewListingStatus.LEASED,
  AccountViewListingStatus.OFF_MARKET,
  AccountViewListingStatus.PARTIALLY_PUBLISHED,
  AccountViewListingStatus.PUBLISHED,
  AccountViewListingStatus.PUBLISHING,
  AccountViewListingStatus.UNABLE_TO_PUBLISH,
  AccountViewListingStatus.WAITLISTED,
] as const;
